// builders/buildScoreboardProps.js
import { ScoreboardType, SchoolType } from '../../enums/scoreboardTypes';
import { getClassLabelKey, isCharedi } from '../../utils/utils';
import { isIdentified, isStudent, isManager, isRegistered, isLeadTeacher, isRegularTeacher, getClassesForDropdown, isHomeroomTeacher, getHomeroomClass, itIsMyCompetition } from './utils';

export const buildScoreboardProps = (state, authState) => {

  const currentStage = state.stages?.find((s) => s.isCurrent);
  let tabs = [{ id: ScoreboardType.SCHOOL, titleKey: 'schoolBoard' }];
  let shouldShowHeaderAndTabs = false;
  let houses = [];
  if (isCharedi())
    houses = currentStage?.houses?.filter(h => h?.isCharedi);
  else
    houses = currentStage?.houses?.filter(h => !h?.isCharedi);
  houses = houses?.map((h) => ({ id: h.name, url: h.jsonUrl })) ?? [];
  if (isIdentified(authState) && isRegistered(state) && itIsMyCompetition(state, authState)) {
    if (isStudent(state)) {
      tabs = [
        { id: ScoreboardType.CLASSES, titleKey: 'classesBoard' },
        { id: ScoreboardType.SCHOOL, titleKey: 'schoolBoard' },
      ];
    }
    else if (isLeadTeacher(state) || isManager(state) || isHomeroomTeacher(authState?.school)) {
      tabs = [
        { id: ScoreboardType.CLASSES, titleKey: "classesBoard" },
        { id: ScoreboardType.SCHOOL, titleKey: 'schoolBoard' },
        { id: ScoreboardType.STUDENTS, titleKey: 'myStudents' },
      ];
    }
    else if (isRegularTeacher(state)) {
      tabs = [
        { id: ScoreboardType.CLASSES, titleKey: "classesBoard" },
        { id: ScoreboardType.SCHOOL, titleKey: 'schoolBoard' },
      ];
    }
    shouldShowHeaderAndTabs = true;
  }

  const banner = {
    items: tabs
      .map((tab) => {
        if (tab.id === ScoreboardType.SCHOOL) {
          return { id: tab.id, tabId: tab.id, textKey: 'mySchoolPlace' };
        }
        if (tab.id === ScoreboardType.CLASSES) {
          if (isHomeroomTeacher(authState.school)) {
            return { id: tab.id, tabId: tab.id, textKey: 'myClassPlace', number: { classKey: getHomeroomClass(authState?.school) ? getClassLabelKey(getHomeroomClass(authState?.school).class) : null, ordinal: getHomeroomClass(authState?.school)?.ordinal } };
          }
          else if (isLeadTeacher(state) || isManager(state) || isRegularTeacher(state))
            return { id: tab.id, tabId: tab.id, textKey: 'SchoolInternalRating', number: { key: "classes", value: "" } };
          else if (isStudent(state))
            return { id: tab.id, tabId: tab.id, textKey: 'myClassPlace', number: { classKey: getClassLabelKey(authState?.user?.studentkita), ordinal: authState?.user?.studentmakbila } };
        }
        if (tab.id === ScoreboardType.STUDENTS)
          return { id: tab.id, tabId: tab.id, textKey: 'topicStudents', number: { key: "", value: state?.schoolAchievements?.participatingStudentsCount } };
        return null;
      })
      .filter(item => item !== null)
  };
  const defaults = {
    activeTabId: ScoreboardType.SCHOOL,
  };

  const classesList = (isLeadTeacher(state) || isManager(state)) ? getClassesForDropdown('school', state.schoolClasses) : (getClassesForDropdown('main', authState?.school?.mainClasses) ?? []);

  return {
    tabs,
    houses,
    banner,
    defaults,
    shouldShowHeaderAndTabs,
    classesList,
  };
};
